import * as React from "react";
import {
  OutletContextProps,
  WithRouterProps,
} from "../../helpers/RouterHelper";
import { AuthenticateRouterProps } from "../../hocs/enhanceAuthenticatedPage";
import enhanceStudentsPage from "../../hocs/enhanceStudentsPage";
import { useFetchStudentKartes } from "../../hooks/http/useFetchStudentKartes";
import { useQueryError } from "../../hooks/http/useQueryError";
import { useOnMainScrollAreaScroll } from "../../hooks/useMainScrollAreaScroll";
import OperatorInterface from "../../interfaces/OperatorInterface";
import { StudentWithStayInterface } from "../../interfaces/StudentInterface";
import StudentKartes from "./StudentKartes";

interface Props
  extends WithRouterProps<AuthenticateRouterProps>,
    OutletContextProps {
  student: StudentWithStayInterface;
  currentOperator: OperatorInterface;
}

const StudentsKartesPage = ({
  student,
  setActiveMenu,
  currentOperator,
}: Props) => {
  React.useEffect(() => {
    setActiveMenu("karte");
  }, []);

  const { kartes, loadMore, isLoading, isFetchingNextPage, error } =
    useFetchStudentKartes({ studentId: student.id });
  useQueryError(error);

  useOnMainScrollAreaScroll(loadMore, [loadMore]);

  return (
    <StudentKartes
      student={student}
      kartes={kartes || []}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      operator={currentOperator}
    />
  );
};

export default enhanceStudentsPage(StudentsKartesPage, {
  title: "カルテ",
});
